"use strict";


//////////////////
// WEBPACK FOOTER
// ../documittu/packages/template/~/styled-material/~/styled-components/lib/types.js
// module id = 24
// module chunks = 0